module.exports = __webpack_public_path__ + "img/_R4A6221.f08f1152.jpg";